import ArrowIcon from "theme/components/icons/ArrowIcon";
import CmsModules from "theme/libs/wordpress/content/CmsModules";
import Column from "theme/layouts/Column";
import CustomerServiceHero from "theme/components/customerService/CustomerServiceHero";
import Link from "core-web/components/Link";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import ThemeButton from "theme/components/buttons/ThemeButton";
import { above } from "core-web/utils/mediaqueries";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";

const StyledList = styled("ul")`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    ${above.tabletLg} {
        gap: 16px;
    }
`;

const Overview = () => {
    const pageContent = useSelector(({ page }) => page.data?.page_content || []);
    const childPages = useSelector(({ page }) => page?.data?.children || []);
    const siblingPages = useSelector(({ page }) => page?.data?.siblings || []);
    const pages = [...siblingPages, ...childPages];

    return (
        <Column gap={["64px", null, null, null, "48px"]}>
            <CustomerServiceHero isOverViewPage />

            {!!pageContent?.length && <CmsModules isCustomerService isWithoutBleedWrapper data={pageContent} />}
            {!!pages?.length && (
                <nav>
                    <StyledList>
                        {pages.map((page, index) => (
                            <li key={`${index}-${page?.permalink}`}>
                                <ThemeButton as={Link} to={page?.permalink || ""} buttonTheme="white_outlined">
                                    <TextStyles as="span" textStyles="Myriad Pro/18-100-semibold-semiextended">
                                        {page.title}
                                    </TextStyles>
                                    <ArrowIcon direction="right" />
                                </ThemeButton>
                            </li>
                        ))}
                    </StyledList>
                </nav>
            )}
        </Column>
    );
};

export default Overview;
